import type { IconName } from '../StIcon/types'
export type CurrencyCode =
  | 'btc'
  | 'bnb'
  | 'eth'
  | 'ltc'
  | 'trx'
  | 'usdc'
  | 'usdt'
  | 'ton'
  | 'pol'
  | 'sol'
  | 'clp'

export interface Network {
  id: number
  name: string
  code: string
  description: string
  icon: IconName
  allowedForDeposit: boolean
  allowedForWithdrawal: boolean
  allowedForCalypso: boolean
  priority?: number
}

export interface Currency {
  id: number
  name: string
  code: Uppercase<string>
  type: 'fiat' | 'crypto'
  codeLowerCase: CurrencyCode
  icon: IconName
  networks: Network[]
  allowedForAccount?: boolean
  allowedForCasino?: boolean
  allowedForDeposit: boolean
  allowedForWithdrawal: boolean
  frontIsDisplayed?: boolean
  priority?: number
  isFiat?: boolean
}

export const currenciesServiceInjectionKey = Symbol(
  'currenciesService',
) as InjectionKey<string>

export interface CurrenciesServiceData {
  getCurrencyById: (id: number) => Currency
  getCurrencyByCode: (code: string) => Currency | undefined
}
